const DATA_TEST_IDS = {
  npiIndividualNpiDataViewIndividual:
    'profile__npi-search-forms_npi-individual_npi-data-view-individual',
} as const;

export default DATA_TEST_IDS;
